<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<h4>បង្កើតតួអង្គថ្មី</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="!loaded">
			<md-card>
				<md-card-content>
					<loading />
				</md-card-content>
			</md-card>
		</div>

		<div class="md-layout-item md-medium-size-100 md-size-100" v-if="loaded">
			<md-card>
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100 text-right">
							<span class="red">{{translate(locale.required)}}</span>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<h4 class>ព័ត៌មានអំពីតួអង្គ</h4>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-50">
									<md-field>
										<label>ឈ្មោះតួអង្គ *</label>
										<md-input type="text" v-model="actor.name"></md-input>
									</md-field>
								</div>
							</div>
						</div>
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-20">
							<div class="md-layout">
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
									<h4 class>រូបភាពតួអង្គ</h4>
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-center">
									<img :src="config.cdn + 'images/' + actor.image_url" class="poster-upload">
								</div>
								<div
									class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-center">
									<input type="file" ref="poster" accept="image/png, image/jpeg"
										@change="handleImage($event)" style="display: none" />
									<md-button class="md-raised md-primary"
										@click="$refs.poster.click()">ផ្ទុករូបភាព</md-button>
								</div>
							</div>
						</div>
						<div
							class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary" @click="updateActor()">កែប្រែ</md-button>
						</div>
					</div>

				</md-card-content>
			</md-card>
		</div>
	</div>

	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getActor();
		},

		data() {
			return {
				loaded: false,
				actor: {
					name: "",
					image_url: "image-poster.png"
				}
			}
		},
		methods: {
			getActor() {
				this.$http.get(this.config.api + "/user/actor/get/" + this.$route.params.hash).then(data => {
					this.actor = data.body.data
					this.loaded = true;
				})
			},
			updateActor() {
				if (String(this.actor.name).length < 3 || String(this.actor.image_url).length < 3) {
					this.$notification.notify({
						message: "សូមបំពេញព័ត៌មានដែលតម្រូវឱ្យបំពេញទាំងអស់។",
						icon: 'info',
						type: 'danger'
					});
					return;
				}

				this.$http.post(this.config.api + "/user/actor/update", {
					actor: this.actor,
					hash: this.$route.params.hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({ message: "អ្នកបានកែប្រែតួអង្គបានដោយជោគជ័យ។", icon: 'check_circle', type: 'success' });
						this.$router.push("/actors");
					}
				})
			},
			handleImage(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs.poster.files[0]);
				this.$http.post(this.config.api + "/user/file/actor", formData).then(res => {
					if (res.body.status == 'success') {
						this.actor.image_url = res.body.data.image_url;
					}
				})
			}
		}
	}
</script>
<style scoped>
	.poster-upload {
		width: 70%;
		max-width: 300px;
	}

	.cover-upload {
		width: 70%;
		max-width: 300px;
	}

	.episode-container {
		border: 1px solid #F0F0F0;
		border-radius: 8px;
		width: 100%;
		display: flex;
		flex-direction: row;
		margin-bottom: 8px;
		background-color: #FFF;
	}

	.episode-order {
		padding: 12px;
		justify-content: center;
		align-items: center;
		display: flex;
	}

	.episode-video {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 12px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Actors/Edit.vue